import { isEmpty, isEqual, forEach } from 'lodash';

import taskManager from '@/utils/task-manager';

import Base from '@/mixins/dashboard/base';
import DashboardAPI from '@/api/dashboard/common';
import DashboardConst from '@/constants/dashboard';

export default {
  mixins: [Base],
  data() {
    return {
      DashboardConst,
      countDown: null,
    };
  },
  computed: {
    selectedNode() {
      return this.$store.getters.selectedNode;
    },
    isEmptyDashboardTree() {
      return isEmpty(this.$store.getters.getDashboardTree(this.dashboardType));
    },
    /**
     * 위젯 View 컴포넌트 반환
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    widgetView() {
      return (layout) => {
        let widgetTemplId;

        if (layout.i === DashboardConst.TEMP_WIDGET_ID) {
          widgetTemplId = 'EmptyWidget';
        } else {
          try {
            // 먼저 위젯 데이터에서 참조하고 없으면,
            widgetTemplId = this.dashboardWidget[layout.i].widgetTemplId;
          } catch (e) {
            try {
              // 레이아웃 정보를 참조한다.
              widgetTemplId = layout.widgetTemplId;
            } catch (e2) {
              // ignore
            }
          }
        }

        // 기본은 빈 위젯
        if (!widgetTemplId) {
          widgetTemplId = 'EmptyWidget';
        }

        return this.$store.getters.getWidgetViewComponent[widgetTemplId];
      };
    },
  },
  watch: {
    selectedNode: {
      immediate: true,
      handler(to, from) {
        if (!isEmpty(to)) {
          if (isEmpty(from) || (!isEmpty(from) && to.dashboardType !== from.dashboardType)) {
            this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.ACTIVE_TREE_TYPE_SET, to.dashboardType);
          }
          if (to.dashboardId && to.dashboardId !== this.currentDashboardId) {
            this.$nextTick(() => {
              this.loadDashboard(to.dashboardId);
            });
          }
        } else {
          this.clearDashboard();
        }
      },
    },
    viewMode: {
      immediate: true,
      handler(to) {
        if (to !== DashboardConst.VIEW_MODE.EDIT) {
          const leftArea = document.querySelector('.drag-content.horiozontal-zone--frame-side');
          const leftAreaDrag = document.querySelector('.drag-handle.horizontal-zone--handle.horizontal');
          if (leftArea) {
            // 좌측 영역 너비 초기화
            leftArea.style.width = null;
            leftArea.style.maxWidth = null;
            leftArea.style.minWidth = '320px';
          }
          if (leftAreaDrag) {
            // 좌측 영역 드래그 커서 초기화
            leftAreaDrag.style.cursor = null;
          }
        } else {
          this.removeWidgetLoadDataTask();
        }

        const rightArea = document.querySelector('.drag-content.horiozontal-zone--frame-main');
        if (rightArea) {
          rightArea.style.width = null;
        }

        // 로테이션 초기화
        this.setRotation(1, 1);

        this.changeViewMode(to === DashboardConst.VIEW_MODE.EDIT);
      },
    },
    isFullScale: {
      immediate: true,
      handler(to) {
        this.changeFullScale(to);
      },
    },
    isResponsive: {
      immediate: true,
      handler() {
        if (!isEmpty(this.$el)) {
          this.responseLayout();
        }
      },
    },
    currentRotationInfo: {
      immediate: true,
      handler(to, from) {
        if (!isEqual(to, from)) {
          this.widgetLoadData();
        }
      },
    },
  },
  created() {
    // 대시보드 로드 이벤트 리스너
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.DASHBOARD_LOAD, this.loadDashboard);
  },
  mounted() {
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.DASHBOARD_LOAD, this.loadDashboard);

    this.clearDashboard();
    this.removeWidgetLoadDataTask();
  },
  methods: {
    /**
     * 대시보드를 로드한다.
     * @author KangBonghun(toto1323)
     * @param  {Number} dashboardId 대시보드 아이디
     * @return {[type]}             [description]
     */
    loadDashboard(dashboardId) {
      if (!dashboardId) {
        throw Error('missing parameter dashboard ID');
      }

      this.showLoading(true);

      // 위젯 instance 모음 초기화
      window.widgetInsts = {};

      DashboardAPI.getDashboard(dashboardId).then((response) => {
        const result = response.data;

        if (result.success) {
          const dashboard = result.data.dashboard;
          const widgetTempl = result.data.widgetTempl;
          const sqlInfo = result.data.sqlInfo;
          const isCustomCtrlDashboard = result.data.isCustomCtrlDashboard;
          const customimage = result.data.customimage;

          this.clearDashboard();
          // View, Setting 컴포넌트를 먼저 로드한다.
          this.loadWidgetComponent(widgetTempl, () => {
            this.$store.commit('setDashboardData', dashboard);
            this.$store.commit('setWidgetTempl', widgetTempl);
            this.$store.commit('setSqlInfo', sqlInfo);
            this.$store.commit('setIsCustomCtrlDashboard', isCustomCtrlDashboard);
            this.$store.commit('setCustomimage', customimage);

            // 대시보드 생성 완료 후 위젯 높이를 조정하고, 위젯 데이터를 로드한다.
            this.$nextTick(() => {
              this.showLoading(false);
              this.createWidgetLoadDataTask();

              // 레이아웃 컴포넌트에서 정의
              this.loadDashboardComplete();
            });
          });
        } else {
          this.clearDashboard();
        }
      }).catch(() => {
        this.clearDashboard();
      });
    },
    /**
     * viewMode가 변경되면 호출된다.
     * @author KangBonghun(toto1323)
     * @param  {Boolean} isEditMode [description]
     * @return {[type]}             [description]
     */
    changeViewMode(/* isEditMode */) {
      // mixin 한 컴포넌트에서 재정의해서 사용하면 된다.
    },
    /**
     * fullScale 상태가 변경되면 호출된다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    changeFullScale(/* fullScale */) {
      // mixin 한 컴포넌트에서 재정의해서 사용하면 된다.
    },
    /**
     * 대시보드 로드가 완료되면 호출된다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    loadDashboardComplete() {
      // mixin 한 컴포넌트에서 재정의해서 사용하면 된다.
    },
    /**
     * store 초기화
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    clearDashboard() {
      this.$store.dispatch('clearDashboard');
    },
    /**
     * 위젯의 View, Setting 컴포넌트를 동적으로 로드한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    loadWidgetComponent(widgetTempl, callback) {
      const widgetViewComponent = {};
      const widgetSettingComponent = {};

      const promiseList = [];

      forEach(widgetTempl, (value, widgetTemplId) => {
        promiseList.push(
          import(`@/views/dashboard/widgets/${this.dashboardType}/view/${widgetTemplId}View.vue`)
            .then((widgetView) => {
              widgetViewComponent[widgetTemplId] = widgetView.default;
            })
            .catch(() => {
              delete widgetViewComponent[widgetTemplId];
            }));
        promiseList.push(
          import(`@/views/dashboard/widgets/${this.dashboardType}/setting/${widgetTemplId}Setting.vue`)
            .then((widgetSetting) => {
              widgetSettingComponent[widgetTemplId] = widgetSetting.default;
            })
            .catch(() => {
              delete widgetSettingComponent[widgetTemplId];
            }));
      });

      // 모든 컴포넌트를 로드 완료 후에 후속조치를 한다.
      Promise.all(promiseList).then(() => {
        this.$store.commit('setWidgetViewComponent', widgetViewComponent);
        this.$store.commit('setWidgetSettingComponent', widgetSettingComponent);

        return callback && callback();
      });
    },
    /**
     * 위젯 새로고침 Task 시작
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    createWidgetLoadDataTask() {
      this.removeWidgetLoadDataTask();

      // 새로고침 주기 (초)
      // 그리드 대시보드는 고정 값 30, 좌표 대시보드는 설정 값
      this.countDown = this.isCoordDashboard ? this.dashboardData.refreshTimer : 30;

      taskManager.createTask(DashboardConst.TASK.WIDGET_LOAD_DATA, 1, this.widgetLoadDataTaskCountDown);
      taskManager.startTask(DashboardConst.TASK.WIDGET_LOAD_DATA);
    },
    /**
     * 위젯 새로고침 Task 종료
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    removeWidgetLoadDataTask() {
      this.countDown = null;
      taskManager.removeTask(DashboardConst.TASK.WIDGET_LOAD_DATA);
      this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.REFRESH_TIMER, 0);
    },
    widgetLoadDataTaskCountDown() {
      if (this.countDown !== null) {
        if (this.countDown === 0) {
          if (this.isMonitoringMode) {
            // 카운트 다운이 완료되고나면 Task는 종료된다.
            // 각 대시보드 레이아웃 컴포넌트에서 위젯로드가 완료 된 적당한 시점에서 createWidgetLoadDataTask함수를 호출하여 Task를 재개시킨다.
            this.removeWidgetLoadDataTask();
            this.widgetLoadData();
          }
        } else {
          // 새로고침 컴포넌트에 현재 타이머 상태 전달
          this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.REFRESH_TIMER, this.countDown);

          if (!isNaN(this.countDown) && this.countDown !== 0 && this.countDown > 0) {
            this.countDown -= 1;
          }
        }
      }
    },
    /**
     * 위젯 새로고침. 어떤방식으로 위젯을 새로고침 할지는 각 대시보드에서 정의한다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    widgetLoadData() {},
    /**
     * 전체화면 도중에 브라우저가 새로고침 된 경우에 전제화면을 재개시킨다.
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    autoDashboardFullScreen() {
      this.$nextTick(() => {
        if (localStorage.getItem('dashboardFullScreen') === this.dashboardType) {
          if (this.isCoordDashboard) {
            this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.COORD_FULL_SCREEN);
          } else if (this.isGridDashboard) {
            this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.GRID_FULL_SCREEN);
          } else {
            localStorage.removeItem('dashboardFullScreen');
          }
        } else {
          localStorage.removeItem('dashboardFullScreen');
        }
      });
    },
    responseLayout() {},
  },
};



// WEBPACK FOOTER //
// ./src/mixins/dashboard/layout.js